import EventEmitter = require("eventemitter3");

class ScrollView {

    private $scrollTrigger: JQuery;
    private $scrollContent: JQuery;
    private scrollTop: number;
    public emitter: EventEmitter;

    public static ScrollEvent: any = {
        ON_SCROLL: "onScroll"
    };

    constructor(scrollTrigger: any, scrollContent?: JQuery) {

        this.$scrollTrigger = scrollTrigger;
        this.$scrollContent = scrollContent;
        this.scrollTop = 0;
        this.emitter = new EventEmitter();
        this.init();
    }


    private init(): void {
        this.$scrollTrigger.on("scroll", this.onScroll.bind(this));
    }

    public onScroll(event: JQuery.Event): void {
        
        this.scrollTop = $('html').scrollTop() || $('body').scrollTop();
        this.emitter.emit(ScrollView.ScrollEvent.ON_SCROLL, this.scrollTop);
    }

    private getScrollTemplate(): JQuery {
        let target: JQuery = null;
        if (this.$scrollContent) {
            target = this.$scrollContent;
        } else {
            target = this.$scrollTrigger;
        }
        return target;
    }

    public scrollToElement(target: JQuery, fixH: number) {

        let offsetTop: number = target.offset().top;
        let targetTop: number = offsetTop - fixH;

        let scrollTarget: any = this.getScrollTemplate();
        scrollTarget.animate({
            scrollTop: targetTop
        }, 1000);
    }
}

export = ScrollView;